export const ACHIEVER_EXPERIENCES: { label: string; value: string }[] = [
  {
    label: "0 - 2 years",
    value: "0-2",
  },
  {
    label: "2 - 5 years",
    value: "2-5",
  },
  {
    label: "5 - 10 years",
    value: "5-10",
  },
  {
    label: "10 - 15 years",
    value: "10-15",
  },
  {
    label: "15 - 20 years",
    value: "15-20",
  },
  {
    label: "20 + years",
    value: "20+",
  },
];
